export default "__VITE_ASSET__D$mujeV7__"